export const filterOptions = [
    { label: 'Gender', value: 'gender', defaultValue: 'All', modal: 'gender', isVisible: true },
    {
        label: 'Rating',
        value: 'utrMin',
        defaultValue: 'All',
        modal: 'utr',
        isVisible: true,
    },
    {
        label: 'Year',
        value: 'hsGradYears',
        defaultValue: 'All',
        modal: 'highSchool',
        isVisible: true,
    },
    {
        label: 'Status',
        value: 'recruitingStatus',
        defaultValue: 'All',
        modal: 'recruitingStatus',
        isVisible: true,
    },
    {
        label: 'Location',
        value: 'location',
        defaultValue: 'All',
        modal: 'location',
        isVisible: true,
    },
    {
        label: 'Nationality',
        value: 'nationality',
        defaultValue: 'All',
        modal: 'nationality',
        isVisible: true,
    },
    {
        label: 'Division',
        value: 'division',
        defaultValue: 'All',
        modal: 'division',
        isVisible: true,
    },
    {
        label: 'Conference',
        value: 'conference',
        defaultValue: 'All',
        modal: 'conference',
        isVisible: true,
    },
    {
        label: 'Snapshot Date',
        value: 'snapshotDate',
        defaultValue: '',
        modal: 'snapshotDate',
        isVisible: true,
    },
    {
        label: 'College Fit Tool',
        value: 'utrFitRating',
        defaultValue: '',
        emptyLabel: '',
        modal: 'utrFit',
        isVisible: true,
    },

];
